<template>
  <div>
    <search-area tabName="用户管理" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="用户昵称" prop="nickName" :label-width="105">
          <Input
            v-model="searchParam.nickName"
            placeholder="请输入用户昵称"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="用户手机号" prop="phone" :label-width="105">
          <Input
            v-model="searchParam.phone"
            placeholder="请输入用户手机号"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="当前状态" prop="nowStatus" :label-width="105">
          <Select
            v-model="searchParam.nowStatus"
            placeholder="请选择当前状态"
            style="width: 200px"
            clearable
          >
            <Option value="1">服务中</Option>
            <Option value="2">空闲中</Option>
            <Option value="3">未上线</Option>
          </Select>
        </FormItem>
        <FormItem label="审核状态" prop="reviewStatus" :label-width="105">
          <Select
            v-model="searchParam.reviewStatus"
            placeholder="请选择审核状态"
            style="width: 200px"
            clearable
          >
            <Option value="0">待审核</Option>
            <Option value="2">通过</Option>
            <Option value="3">不通过</Option>
          </Select>
        </FormItem>
        <FormItem label="角色" prop="type" :label-width="105">
          <Input
            v-model="searchParam.type"
            placeholder="请输入角色"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="small"
            @click="$router.push({ path: '/useradd' })"
            >新增用户</Button
          >
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="userList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>

    <!-- 用户详情弹窗 -->
    <Modal
      v-model="showUserDetail"
      title="用户详情"
      :mask-closable="false"
      width="600"
    >
      <div v-if="currentUser">
        <Form :model="currentUser" :label-width="100">
          <FormItem label="用户ID:">
            <span>{{ currentUser.id }}</span>
          </FormItem>
          <FormItem label="用户昵称:">
            <span>{{ currentUser.nickName }}</span>
          </FormItem>
          <FormItem label="手机号:">
            <span>{{ currentUser.phone }}</span>
          </FormItem>
          <FormItem label="注册时间:">
            <span>{{ currentUser.createDt }}</span>
          </FormItem>
          <FormItem label="最后登录:">
            <span>{{ currentUser.lastTime }}</span>
          </FormItem>
          <FormItem label="用户状态:">
            <Tag :color="currentUser.status === 1 ? 'success' : 'error'">
              {{ currentUser.status === 1 ? "正常" : "禁用" }}
            </Tag>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="showUserDetail = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import columns from "./user-column.js";

export default {
  name: "UserManagement",
  data() {
    return {
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        nickName: "",
        phone: "",
        nowStatus: "",
        reviewStatus: "",
        type: "",
      },
      userList: [],
      total: 0,
      columns: columns(this),
      showUserDetail: false,
      currentUser: null,
    };
  },
  mounted() {
    this.search(1);
  },
  methods: {
    async search(page) {
      this.searchParam.currentPage = page;
      try {
        const { list, total } = await this.$post(
          "/user/listByPage",
          this.searchParam
        );
        this.userList = list || [];
        this.total = total || 0;
      } catch (error) {
        console.error("获取用户列表失败:", error);
        this.$Message.error("获取用户列表失败");
      }
    },

    async handleStatusChange(userId, status) {
      try {
        const res = await this.$post("/user/updateStatus", { userId, status });
        this.$Message.success("状态更新成功");
        this.search(this.searchParam.currentPage);
      } catch (error) {
        console.error("状态更新失败:", error);
        this.$Message.error("状态更新失败");
      }
    },

    async handleDelete(userId) {
      try {
        await this.$get("/user/delete", { userIds: userId });
        this.$Message.success("删除成功");
        this.search(this.searchParam.currentPage);
      } catch (error) {
        console.error("删除失败:", error);
        this.$Message.error("删除失败");
      }
    },

    async showDetail(user) {
      try {
        const userInfo = await this.$get("/user/getUserInfo", {
          userId: user.userId,
        });
        this.currentUser = userInfo;
        this.showUserDetail = true;
      } catch (error) {
        console.error("获取用户详情失败:", error);
        this.$Message.error("获取用户详情失败");
      }
    },
  },
};
</script>

<style scoped></style>
